import { createSlice } from "@reduxjs/toolkit";
import {
  GET_TERRITORY_SUCCESS,
  GET_TERRITORY_FAIL,
  GET_CLUSTER_CODE_SUCCESS,
  GET_CLUSTER_CODE_FAIL,
  GET_RBDM_CODE_SUCCESS,
  GET_RBDM_CODE_FAIL,
} from "../constants/action-types";

// --- Territory Slice ---
const territorySlice = createSlice({
  name: "territory",
  initialState: { territoryDetails: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_TERRITORY_SUCCESS, (state, { payload }) => {
        state.territoryDetails = payload;
      })
      .addCase(GET_TERRITORY_FAIL, (state) => {
        state.territoryDetails = [];
      });
  },
});

// --- Cluster Code Slice ---
const clusterCodeSlice = createSlice({
  name: "clusterCode",
  initialState: { clusterCodeList: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_CLUSTER_CODE_SUCCESS, (state, { payload }) => {
        state.clusterCodeList = payload;
      })
      .addCase(GET_CLUSTER_CODE_FAIL, (state) => {
        state.clusterCodeList = [];
      });
  },
});

// --- RBDM Code Slice ---
const rbdmCodeSlice = createSlice({
  name: "RBDMCode",
  initialState: { RBDMCode: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_RBDM_CODE_SUCCESS, (state, { payload }) => {
        state.RBDMCode = payload;
      })
      .addCase(GET_RBDM_CODE_FAIL, (state) => {
        state.RBDMCode = [];
      });
  },
});

export const territoryDetailsReducer = territorySlice.reducer;
export const clusterCodeReducer = clusterCodeSlice.reducer;
export const RBDMCodeReducer = rbdmCodeSlice.reducer;
